document.addEventListener('DOMContentLoaded', function () {
  // initialise every rendered calculator on page (support multiple instances)
  document.querySelectorAll('.bpa').forEach(container => {
    // find instance-specific elements by id prefix used in snippet (ids include instance id)
    const prefix = (container.id || '').replace(/-?$/, '');
    const q = id => document.getElementById(`${prefix ? prefix + '-' : ''}${id}`);

    const LEl = q('l') || container.querySelector('input[id$="-l"]');
    const WEl = q('w') || container.querySelector('input[id$="-w"]');
    const HEl = q('h') || container.querySelector('input[id$="-h"]');
    const unitsEl = q('units') || container.querySelector('select[id$="-units"]');
    const allowEl = q('allow') || container.querySelector('input[id$="-allow"]');
    const calcBtn = q('calc') || container.querySelector('button[id$="-calc"]');
    const out = q('results') || container.querySelector('[id$="-results"]');

    if (!LEl || !WEl || !HEl || !unitsEl || !allowEl || !calcBtn || !out) return;

    // ***** EDIT THIS LIST TO MATCH YOUR CATALOG (internal usable size in mm) *****
   const MAILERS = window.MAILERS || [];

    function toMM(value, units) {
      const v = Number(value);
      if (isNaN(v) || v < 0) return NaN;
      if (units === 'mm') return v;
      if (units === 'cm') return v * 10;
      if (units === 'in') return v * 25.4;
      return NaN;
    }

    function requirementsFor(boxDims, lenIdx, allowance) {
      const dims = boxDims.slice();
      const len = dims[lenIdx];
      const cross = dims.filter((_, i) => i !== lenIdx);
      const depth = Math.min(cross[0], cross[1]);
      const face = Math.max(cross[0], cross[1]);
      return {
        widthReq: face + depth + allowance,
        lengthReq: len + depth + allowance
      };
    }

    function rankedFits(boxDims, allowance, mailers) {
      const reqs = [0, 1, 2].map(i => ({ i, ...requirementsFor(boxDims, i, allowance) }));
      const valid = mailers.filter(m => reqs.some(r => r.widthReq <= m.width_mm && r.lengthReq <= m.length_mm));
      valid.sort((a, b) => (a.width_mm * a.length_mm) - (b.width_mm * b.length_mm) || (a.length_mm - b.length_mm));
      return { valid, reqs };
    }

    function fmt(mm, units) {
      if (units === 'mm') return `${Math.round(mm)} mm`;
      if (units === 'cm') return `${(mm / 10).toFixed(1)} cm`;
      if (units === 'in') return `${(mm / 25.4).toFixed(2)} in`;
      return `${mm} mm`;
    }

    function render() {
      const L = LEl.value;
      const W = WEl.value;
      const H = HEl.value;
      const units = unitsEl.value;
      const allow = allowEl.value ?? 0;

      const lmm = toMM(L, units), wmm = toMM(W, units), hmm = toMM(H, units), amm = toMM(allow, 'mm');
      const baseAllowance = 5; // mm always applied
      const totalAllowance = (isNaN(amm) ? 0 : amm) + baseAllowance;

      out.hidden = false;

      if ([lmm, wmm, hmm, amm].some(isNaN)) {
        out.innerHTML = `<div class="bpa__empty">Please enter valid numeric dimensions.</div>`;
        return;
      }

      const { valid: fits } = rankedFits([lmm, wmm, hmm], totalAllowance, MAILERS);

      if (!fits.length) {
        out.innerHTML = `<div class="bpa__empty"><strong>No fit found.</strong> Try reducing allowance or using a larger satchel/carton.</div>`;
        return;
      }

      out.innerHTML = fits.map((m, i) => `
        <div class="bpa__card" role="article" aria-label="${m.name}">
          <div class="bpa__grid">
            <div>
              <div class="bpa__name">${m.name}</div>
              <div class="bpa__dim">Internal: ${fmt(m.width_mm, units)} × ${fmt(m.length_mm, units)}</div>
              ${i === 0 ? `<span class="bpa__chip">Best fit</span>` : ``}
            </div>
            <div class="bpa__buy">
              ${m.productUrl ? `<a href="${m.productUrl}">View product</a>` : ``}
            </div>
          </div>
        </div>
      `).join('') + `<div class="bpa__note">Rule: width ≥ (other two sides summed), length ≥ (long side + smaller of the other two). We always add +5&nbsp;mm, plus any extra allowance you enter.</div>`;
    }

    calcBtn.addEventListener('click', render);
  });
});